export default ({ label, title }) => <span>{label}: <strong>{title}</strong></span>
